import { render, staticRenderFns } from "./Motivos.vue?vue&type=template&id=c9da1b7e"
import script from "./Motivos.vue?vue&type=script&lang=js"
export * from "./Motivos.vue?vue&type=script&lang=js"
import style0 from "./Motivos.vue?vue&type=style&index=0&id=c9da1b7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VBtn,VIcon,VSkeletonLoader})
